// PartA5Accomplishments.js
import React from 'react';

const PartA5Accomplishments = ({ formData, handleInputChange }) => {

    // Helper to toggle selection
    const toggleSelection = (key) => {
        handleInputChange(key, !formData[key]);
    };

    // Header Cell (Left Column) - Identical style to Report
    const HeaderCell = ({ label, rowSpan = 1, className = "" }) => (
        <div
            className={`bg-[#ED7D31] text-white font-bold p-2 flex items-center justify-center text-center text-sm leading-tight border-b-2 border-white ${className}`}
            style={{ gridRow: `span ${rowSpan}` }}
        >
            {label}
        </div>
    );

    // Content Cell - Identical style to Report but with onClick
    const Cell = ({ label, fieldKey, className = "" }) => {
        const isSelected = formData[fieldKey];
        return (
            <div
                onClick={() => toggleSelection(fieldKey)}
                className={`
                    flex items-center justify-center p-1 cursor-pointer
                    border-r border-b border-[#ED7D31] last:border-r-0
                    bg-[#FCE4D6] ${className}
                `}
            >
                <div className={`
                    w-full h-full flex items-center justify-center text-center text-sm font-medium p-2 rounded-[1rem] transition-all
                    ${isSelected ? 'border-2 border-[#ED7D31] bg-white shadow-sm' : 'hover:bg-[#ED7D31]/10'}
                `}>
                    {label}
                </div>
            </div>
        );
    };

    return (
        <div className="a4-page font-[poppins] bg-white p-8 mx-auto text-[#333333]" style={{ maxWidth: '100%', width: '100%' }}>

            {/* Header */}
            <div className="text-center mb-6">
                <h2 className="text-xl font-bold text-[#ED7D31] mb-1">PART A (5)</h2>
                <h3 className="text-lg font-bold text-black">Accomplishments Inventory</h3>
            </div>

            {/* Intro Text */}
            <p className="mb-6 text-sm leading-relaxed text-justify text-black">
                This <span className="font-bold">inventory</span> will help you keep track of the necessary <span className="font-bold">steps</span> and <span className="font-bold">skills</span> that you may need as you move through school towards your next step. Circle the box that indicates that you have already taken the steps and skills that you have already acquired. Keep coming back to this <span className="font-bold">Inventory</span> till all the boxes have been circled!
            </p>

            {/* Inventory Table */}
            <div className="grid grid-cols-4 border-t border-l border-[#ED7D31] rounded-sm overflow-hidden">

                {/* Row 1 */}
                <HeaderCell label="Have I gathered Information about..." />
                <Cell label="Entrance exams I may appear for" fieldKey="info_entrance_exams" />
                <Cell label="College(s)/University(ies)/ Skill Institutes (national/international) I want to apply to" fieldKey="info_colleges" />
                <Cell label="Prospective job roles/opportunities" fieldKey="info_job_roles" className="border-r-0" />

                {/* Row 2 */}
                <HeaderCell label="Have I started preparation for..." />
                <Cell label="Entrance test(s) and/or interviews" fieldKey="prep_entrance_tests" />
                <Cell label="Filling out college/skill institute/professional institute forms" fieldKey="prep_forms" />
                <Cell label="Creating a portfolio highlighting my skills and achievements" fieldKey="prep_portfolio" className="border-r-0" />

                {/* Row 3 (Spans 2 rows) */}
                <HeaderCell label="Have I acquired academic skills like..." rowSpan={2} />

                <Cell label="Thinking critically and creatively" fieldKey="skill_academic_thinking" />
                <Cell label="Collaborating with peers and respecting various perspectives" fieldKey="skill_academic_collaborating" />
                <Cell label="Engaging in independent work/research" fieldKey="skill_academic_research" className="border-r-0" />

                <Cell label="Using technology and searching for and accessing information online" fieldKey="skill_academic_tech" />
                <Cell label="The ability to follow directions and manage ambiguity" fieldKey="skill_academic_directions" />
                <Cell label="Managing my time and developing study skills" fieldKey="skill_academic_time" className="border-r-0" />

                {/* Row 4 (Spans 2 rows) */}
                <HeaderCell label="Have I acquired life skills like..." rowSpan={2} />

                <Cell label="Understanding the value of money and budgeting" fieldKey="skill_life_money" />
                <Cell label="Managing stress for self and others" fieldKey="skill_life_stress" />
                <Cell label="Being safe and avoiding risky behaviours" fieldKey="skill_life_safety" className="border-r-0" />

                <Cell label="Developing holistic self-care routines" fieldKey="skill_life_selfcare" />
                <Cell label="Upholding integrity and respecting institutional rules and policies" fieldKey="skill_life_integrity" />
                <Cell label="Asking for help/ assistance when needed" fieldKey="skill_life_help" className="border-r-0" />

                {/* Row 5 (Spans 2 rows) */}
                <HeaderCell label="Have I worked to develop personal qualities like..." rowSpan={2} className="border-b-0" />

                <Cell label="Mutual respect and tolerance" fieldKey="quality_respect" />
                <Cell label="Empathy" fieldKey="quality_empathy" />
                <Cell label="Resilience" fieldKey="quality_resilience" className="border-r-0" />

                <Cell label="Good citizenship" fieldKey="quality_citizenship" className="border-b-0" />
                <Cell label="Appreciation for sustainability" fieldKey="quality_sustainability" className="border-b-0" />
                <Cell label="Concern for society" fieldKey="quality_society" className="border-r-0 border-b-0" />

            </div>
        </div>
    );
};

export default PartA5Accomplishments;
